import { buildFramePrompt } from './aiPrompts'

const FRAME_CHAR_LIMIT = 1600

const baseStudentInfo = (v) => ({
  year: v.year,
  frenchProgram: v.frenchProgram,
  daysAbsent: v.daysAbsent,
  timesLate: v.timesLate,
})

export const BELONGING_CONFIG = {
  systemPrompt: buildFramePrompt('belonging', FRAME_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    ...baseStudentInfo(v),
    esl: v.belongingEsl,
    iep: v.belongingIep,
  }),
}

export const SELF_REGULATION_CONFIG = {
  systemPrompt: buildFramePrompt('selfRegulation', FRAME_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    ...baseStudentInfo(v),
    esl: v.selfRegulationEsl,
    iep: v.selfRegulationIep,
  }),
}

export const LITERACY_MATH_CONFIG = {
  systemPrompt: buildFramePrompt('literacyMath', FRAME_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    ...baseStudentInfo(v),
    esl: v.literacyMathEsl,
    iep: v.literacyMathIep,
  }),
}

export const PROBLEM_SOLVING_CONFIG = {
  systemPrompt: buildFramePrompt('problemSolving', FRAME_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    ...baseStudentInfo(v),
    esl: v.problemSolvingEsl,
    iep: v.problemSolvingIep,
  }),
}
